<template>
  <v-card>
    <v-container fluid>
      <v-layout 
        :column="$vuetify.breakpoint.xsOnly"
        :justify-space-around="!$vuetify.breakpoint.smAndDown"
      >
        <v-layout column>
          <v-layout wrap>
            <v-flex
              xs12 sm10 md5 xl4    
            >
              <v-text-field
                v-model="search"
                append-icon="search"
                :label="$t('general.misc.buscar')"
              />
            </v-flex>
            <v-flex
              xs12 sm10 md5 xl4 
              :class="$vuetify.breakpoint.mdAndUp ? 'pl-4' : ''"         
            >
              <o-select-todos
                v-model="estadosSelect"
                :textoTodos="$t('general.misc.todos')"
                :items="estados"
                :label="$t('general.misc.estado')"
                item-text="descripcion"
                item-value="codigo"
                class="multipleSelect selectText"
                multiple
              >
                <v-list-tile
                  slot="prepend-item"
                  ripple
                  @click.stop="toggleSelectEstados"
                >
                  <v-list-tile-action>
                    <v-icon :color="estadosSelect.length > 0 ? 'primary' : ''">{{ iconoEstados }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title :class="estadosSelect.length > 0 ? 'primary--text' : ''">{{estadosSelect.length === estados.length ? $t('general.misc.deseleccionarTodos') : $t('general.misc.seleccionarTodos')}}</v-list-tile-title>
                </v-list-tile>
              </o-select-todos>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex
              xs12 sm10 md5 xl4    
            >
              <o-select-todos
                v-model="promocionesSelect"
                :textoTodos="$t('general.misc.todas')"
                :items="promociones"
                :label="$t('general.misc.promociones')"
                item-text="descripcion"
                item-value="codigo"
                class="multipleSelect selectText"
                multiple
              >
                <v-list-tile
                  slot="prepend-item"
                  ripple
                  @click.stop="toggleSelect"
                >
                  <v-list-tile-action>
                    <v-icon :color="promocionesSelect.length > 0 ? 'primary' : ''">{{ icono }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title :class="promocionesSelect.length > 0 ? 'primary--text' : ''">{{promocionesSelect.length === promociones.length ? $t('general.misc.deseleccionarTodas') : $t('general.misc.seleccionarTodas')}}</v-list-tile-title>
                </v-list-tile>
              </o-select-todos>
            </v-flex>
            <v-flex
              xs12 sm10 md5 xl4 
              :class="$vuetify.breakpoint.mdAndUp ? 'pl-4' : ''"         
            >
              <o-select-todos
                v-model="rolesSelect"
                :textoTodos="$t('general.misc.todos')"
                :items="roles"
                :label="$t('general.misc.roles')"
                item-text="descripcion"
                item-value="codigo"
                class="multipleSelect selectText"
                multiple
              >
                <v-list-tile
                  slot="prepend-item"
                  ripple
                  @click.stop="toggleSelectRoles"
                >
                  <v-list-tile-action>
                    <v-icon :color="rolesSelect.length > 0 ? 'primary' : ''">{{ iconoRoles }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title :class="rolesSelect.length > 0 ? 'primary--text' : ''">{{rolesSelect.length === roles.length ? $t('general.misc.deseleccionarTodos') : $t('general.misc.seleccionarTodos')}}</v-list-tile-title>
                </v-list-tile>
              </o-select-todos>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-flex shrink class="text-xs-right">
          <v-btn :disabled="waitingForLoad" color="primary" @click.stop="mostrarEditar(true, 0)">
            {{$t('general.misc.nuevoUsuario')}}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="filteredItems"
            :loading="waitingForLoad"
            :expand="$vuetify.breakpoint.mdAndDown"
          >
            <template slot="items" slot-scope="props">
              <tr class="pointer" @click="props.expanded = !props.expanded">
                <td class="text-xs-left">
                  <v-layout row>
                    {{ props.item.nombre }}
                    <v-spacer/>
                    <v-icon
                      v-if="$vuetify.breakpoint.smAndDown || props.item.promociones.length > 0"
                      :style="props.expanded ? 'transform: rotate(-180deg)' : ''"
                    > 
                      keyboard_arrow_down 
                    </v-icon>
                  </v-layout>
                </td>
                <td class="text-xs-center hidden-xs-only tableSmallPadding">
                  {{ props.item.EMAIL_ACTOR }}
                </td>
                <td class="text-xs-center hidden-sm-and-down tableSmallPadding">
                  {{ rolesActor(props.item) }}
                </td>
                <td class="text-xs-center hidden-md-and-down tableSmallPadding">
                  {{ estadoActor(props.item).estado }}
                </td>
                <td class="text-xs-right hidden-sm-and-down tableSmallPadding">
                  <v-tooltip bottom>
                    <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarEditar(false, getIndex(props.item))">
                      <v-icon color="primary">
                        edit
                      </v-icon>
                    </v-btn>
                    <span>{{$t('general.misc.editar')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarEditarPromociones(getIndex(props.item))">
                      <v-icon color="primary">
                        mdi-home-city
                      </v-icon>
                    </v-btn>
                    <span>{{$t('general.misc.editarPromociones')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn :disabled="props.item.estado === '91'"  flat icon slot="activator" class="smallTableButton" @click.stop="mostrarBloquear(getIndex(props.item))">
                      <v-icon color="primary"> 
                        {{estadoActor(props.item).iconoAccion}}
                      </v-icon>
                    </v-btn>
                    <span>
                      {{estadoActor(props.item).textoAccion}}
                    </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn :disabled="props.item.estado === '91'" flat icon slot="activator" class="smallTableButton" @click.stop="mostrarBorrar(getIndex(props.item))">
                      <v-icon color="primary" class="custom-icon">
                        icon-action_erase
                      </v-icon>
                    </v-btn>
                    <span>{{$t('general.misc.eliminar')}}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-right hidden-md-and-up tableSmallPadding">
                  <v-menu offset-y left @click.native.stop>
                    <v-btn flat icon title="Gestionar" slot="activator" class="smallTableButton">
                      <v-icon color="primary">
                        more_vert
                      </v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile @click="mostrarEditar(false, getIndex(props.item))">
                        <v-list-tile-action>
                          <v-icon color="primary"> 
                            edit 
                          </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('general.misc.editar')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile @click="mostrarEditarPromociones(getIndex(props.item))">
                        <v-list-tile-action>
                          <v-icon color="primary"> 
                            mdi-home-city 
                          </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('general.misc.editarPromociones')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile :disabled="props.item.estado === '91'" @click="mostrarBloquear(getIndex(props.item))">
                        <v-list-tile-action>
                          <v-icon :disabled="props.item.estado === '91'" color="primary"> 
                            {{estadoActor(props.item).iconoAccion}}
                          </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{estadoActor(props.item).textoAccion}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile :disabled="props.item.estado === '91'" @click="mostrarBorrar(getIndex(props.item))">
                        <v-list-tile-action>
                          <v-icon :disabled="props.item.estado === '91'" color="primary" class="custom-icon"> 
                            icon-action_erase 
                          </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('general.misc.eliminar')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template 
              v-if="$vuetify.breakpoint.smAndDown || props.item.promociones.length > 0" 
              slot="expand" slot-scope="props"
            >
              <v-list dense>
                <v-list-tile
                  v-if="$vuetify.breakpoint.xsOnly"
                >
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-icon color="primary" slot="activator"> mdi-account </v-icon>
                      <span>{{$t('general.misc.cliente')}}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-layout row align-center>
                      <v-flex>
                        {{props.item.EMAIL_ACTOR}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-if="$vuetify.breakpoint.smAndDown"
                >
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-icon color="primary" slot="activator"> mdi-account-details </v-icon>
                      <span>{{$t('general.misc.roles')}}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-layout row align-center>
                      <v-flex>
                        {{ rolesActor(props.item) }}
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-if="$vuetify.breakpoint.mdAndDown"
                >
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-icon color="primary" slot="activator"> 
                        {{ estadoActor(props.item).icono }}   
                      </v-icon>
                      <span>{{$t('general.misc.estado')}}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-layout row align-center>
                      <v-flex> 
                        {{ estadoActor(props.item).estado }} 
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile 
                  v-for="(promocion, index) in props.item.promociones"
                  :key="index"
                >
                  <v-list-tile-content>
                    <v-layout row align-center>
                      <v-flex>
                        {{promocion.descripcion}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarEditarPromocionesComercial" 
        v-model="mostrarEditarPromocionesComercial"
        :cambiado="cambiado"
        @aceptar="mostrarEditarPromocionesComercial = $event"
      >
        <EditarPromocionesComercial
          :comercialEditado="items[indexComercialEditar]"
          @cambiado="cambiado = $event"
          @recargar="initialize"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarEditarComercial" 
        v-model="mostrarEditarComercial"
        :cambiado="cambiado"
        @aceptar="mostrarEditarComercial = $event"
      >
        <EditarComercial 
          :nuevoComercial="nuevoComercial" 
          :comercialEditado="items[indexComercialEditar]"
          @cambiado="cambiado = $event"
          @recargar="initialize"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <PopUpSeguro
        v-if="mostrarBorrarComercial"
        @aceptar="borrarComercial"
        :titulo="$t('general.misc.eliminarUsuario')"
        :alerta="$t('general.popUpSeguro.alertaIrreversible')"
        :pregunta="$t('general.popUpSeguro.preguntaEliminarUsuario', {usuario: items[indexComercialEditar].nombre})"
        :descartar="$t('general.misc.eliminar')"
        :cancelar="$t('general.popUpSeguro.cancelar')"
      />
    </v-fade-transition>
    <v-fade-transition>
      <PopUpSeguro
        v-if="mostrarBloquearComercial"
        @aceptar="bloquearComercial"
        :titulo="estadoActor(comercialEditado).textoAccion + ' ' + $t('general.misc.usuario')"
        :pregunta="estadoActor(comercialEditado).preguntaPopup"
        :alerta="''"
        :descartar="estadoActor(comercialEditado).textoAccion.toUpperCase()"
        :cancelar="$t('general.popUpSeguro.cancelar')"
      />
    </v-fade-transition>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/mixins/rules.js'
import EditarPromocionesComercial from './EditarPromocionesComercial'
import EditarComercial from './EditarComercial'
import PopUpSeguro from '@/components/generic/PopUpSeguro'

export default {
  mixins: [
    rulesMixin
  ],
  components: {
    EditarPromocionesComercial,
    EditarComercial,
    PopUpSeguro
  },
  data () {
    return {
      items: [],
      mostrarBloquearComercial: false,
      mostrarEditarPromocionesComercial: false,
      mostrarEditarComercial: false,
      mostrarBorrarComercial: false,
      promocionesSelect: [],
      rolesSelect: [],
      estadosSelect: [],
      search: null,
      waitingForLoad: false,
      nuevoComercial: false,
      indexComercialEditar: 0,
      cambiado: false
    }
  },
  created () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      promociones: 'promociones/getAll',
      comerciales: 'comerciales/getAll',
      roles: 'maestros/roles/getAll'
    }),
    estados () {
      return [
        {
          descripcion: this.$t('comerciales.estadoActivo'),
          codigo: '10'
        },
        {
          descripcion: this.$t('comerciales.estadoBloqueado'),
          codigo: '90'
        },
        {
          descripcion: this.$t('comerciales.estadoBloqueadoAPP'),
          codigo: '91'
        }
      ]
    },
    headers () {
      return [
        {
          text: this.$t('general.misc.nombre'),
          value: 'nombre',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.misc.email'),
          value: 'EMAIL_ACTOR',
          align: 'center',
          class: 'hidden-xs-only',
          sortable: true
        },
        {
          text: this.$t('general.misc.roles'),
          value: 'EMAIL_ACTOR',
          align: 'center',
          class: 'hidden-sm-and-down',
          sortable: false
        },
        {
          text: this.$t('general.misc.estado'),
          value: 'estado',
          align: 'center',
          class: 'hidden-md-and-down',
          sortable: false
        },
        {
          text: '',
          class: 'hidden-md-and-up',
          sortable: false
        },
        {
          text: this.$t('general.misc.acciones'),
          align: 'right',
          class: 'hidden-sm-and-down',
          sortable: false
        }
      ]
    },
    filteredItems () {
      if (this.waitingForLoad) {
        return []
      }
      let auxItems = this.items
      if (this.search != null && this.search.length > 0) {
        let normalizedSearchValue = this.search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        auxItems = auxItems.filter(x =>
          (x.NOMBRE_ACTOR.normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .includes(normalizedSearchValue) ||
          x.EMAIL_ACTOR.normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .includes(normalizedSearchValue))
        )
      }
      if (this.promocionesSelect.length > 0) {
        auxItems = auxItems.filter(x => {
          return x.promociones.some(p => {
            return this.promocionesSelect.includes(p.codigo)
          })
        })
      }
      if (this.rolesSelect.length > 0) {
        auxItems = auxItems.filter(x => {
          return x.roles.some(rol => {
            return this.rolesSelect.includes(rol)
          })
        })
      }
      if (this.estadosSelect.length > 0) {
        auxItems = auxItems.filter(x => {
          return this.estadosSelect.includes(x.estado)
        })
      }
      return auxItems
    },
    comercialEditado () {
      return this.items[this.indexComercialEditar]
    },
    icono () {
      if (this.allSelect) return 'mdi-close-box'
      if (this.multipleSelect) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allSelect () {
      return this.promocionesSelect.length === this.promociones.length
    },
    multipleSelect () {
      return this.promocionesSelect.length > 0 && !this.allSelect
    },
    iconoRoles () {
      if (this.allSelectRoles) return 'mdi-close-box'
      if (this.multipleSelectRoles) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allSelectRoles () {
      return this.rolesSelect.length === this.roles.length
    },
    multipleSelectRoles () {
      return this.rolesSelect.length > 0 && !this.allSelectRoles
    },
    iconoEstados () {
      if (this.allSelectEstados) return 'mdi-close-box'
      if (this.multipleSelectEstados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allSelectEstados () {
      return this.estadosSelect.length === this.estados.length
    },
    multipleSelectEstados () {
      return this.estadosSelect.length > 0 && !this.allSelectEstados
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadTiposDocumentos: 'maestros/loadTiposDocumentos',
      loadPromociones: 'promociones/loadAll',
      loadComerciales: 'comerciales/loadAll',
      bloquear: 'comerciales/bloquear',
      desbloquear: 'comerciales/desbloquear',
      borrar: 'comerciales/borrar'
    }),
    getIndex (comercial) {
      return this.items.findIndex(x => x.ID_ACTOR === comercial.ID_ACTOR)
    },
    mostrarBloquear (index) {
      this.indexComercialEditar = index
      this.mostrarBloquearComercial = true
    },
    mostrarBorrar (index) {
      this.indexComercialEditar = index
      this.mostrarBorrarComercial = true
    },
    mostrarEditarPromociones (index) {
      this.cambiado = false
      this.indexComercialEditar = index
      this.mostrarEditarPromocionesComercial = true
    },
    mostrarEditar (nuevoComercial, index) {
      this.cambiado = false
      this.indexComercialEditar = index
      this.nuevoComercial = nuevoComercial
      this.mostrarEditarComercial = true
    },
    toggleSelect () {
      this.$nextTick(() => {
        if (this.allSelect) {
          this.promocionesSelect = []
        } else {
          this.promocionesSelect = this.promociones.map(x => x.codigo)
        }
      })
    },
    toggleSelectRoles () {
      this.$nextTick(() => {
        if (this.allSelectRoles) {
          this.rolesSelect = []
        } else {
          this.rolesSelect = this.roles.map(x => x.codigo)
        }
      })
    },
    toggleSelectEstados () {
      this.$nextTick(() => {
        if (this.allSelectEstados) {
          this.estadosSelect = []
        } else {
          this.estadosSelect = this.estados.map(x => x.codigo)
        }
      })
    },
    async bloquearComercial (aux) {
      if (!aux) {
        this.mostrarBloquearComercial = false
        return
      }
      try {
        this.waitingForLoad = true
        this.mostrarBloquearComercial = false
        if (this.comercialEditado.ESTADO_ASOC_IDUBAPI === '10') {
          await this.bloquear(this.comercialEditado.ID_ACTOR)
        } else {
          await this.desbloquear(this.comercialEditado.ID_ACTOR)
        }
        this.addAlert(
          {
            texto: this.$t('comerciales.alertaBloquear', {accion: (this.comercialEditado.ESTADO_ASOC_IDUBAPI === '10' ? this.$t('general.misc.bloqueado') : this.$t('general.misc.desbloqueado'))}),
            color: 'success'
          })
        await this.initialize()
        this.waitingForLoad = false
      } catch (error) {
        this.initialize()
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    async borrarComercial (aux) {
      if (!aux) {
        this.mostrarBorrarComercial = false
        return
      }
      try {
        this.waitingForLoad = true
        this.mostrarBorrarComercial = false
        await this.borrar(this.comercialEditado.ID_ACTOR)
        await this.initialize()
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    async initialize () {
      try {
        this.waitingForLoad = true
        await Promise.all([
          this.loadComerciales(),
          this.loadPromociones(),
          this.loadTiposDocumentos()
        ])
        this.items = this.comerciales.filter(x => x.FECHA_BAJA_ACTOR === '')
          .map(x => {
            return {
              id: x.ID_ACTOR,
              nombre: this.nombreActor(x),
              ...x,
              estado: x.ESTADO_ACTOR === '90' ? '91' : x.ESTADO_ASOC_IDUBAPI,
              expanded: false
            }
          })
        // this.promocionesSelect = this.promociones.map(x => x.codigo)
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    nombreActor (actor) {
      if (!actor.APELLIDOS_ACTOR) {
        return actor.NOMBRE_ACTOR
      } else {
        return actor.APELLIDOS_ACTOR + ', ' + actor.NOMBRE_ACTOR
      }
    },
    estadoActor (actor) {
      switch (actor.estado) {
        case '10':
          return {
            estado: this.$t('comerciales.estadoActivo'),
            icono: 'mdi-account-check',
            iconoAccion: 'mdi-lock-alert',
            textoAccion: this.$t('general.misc.bloquear'),
            preguntaPopup: this.$t('comerciales.preguntaPopUpBloquear', {usuario: actor.nombre})
          }
        case '90':
          return {
            estado: this.$t('comerciales.estadoBloqueado'),
            icono: 'mdi-account-off',
            iconoAccion: 'mdi-lock-open-outline',
            textoAccion: this.$t('general.misc.desbloquear'),
            preguntaPopup: this.$t('comerciales.preguntaPopUpDesbloquear', {usuario: actor.nombre})
          }
        case '91':
          return {
            estado: this.$t('comerciales.estadoBloqueadoAPP'),
            icono: 'mdi-account-off',
            iconoAccion: 'mdi-lock-open-outline',
            textoAccion: this.$t('general.misc.desbloquear'),
            preguntaPopup: this.$t('comerciales.preguntaPopUpDesbloquear', {usuario: actor.nombre})
          }
        default:
          return {
            estado: 'Error',
            icono: 'mdi-alert',
            iconoAccion: 'mdi-alert',
            textoAccion: this.$t('general.misc.error'),
            preguntaPopup: this.$t('comerciales.preguntaPopUpErrorDefault')
          }
      }
    },
    rolesActor (actor) {
      return actor.roles.map(x => {
        switch (x) {
          case 'VD_COMERCIAL':
            return this.$t('store.rolComercial')
          case 'VD_PBC':
            return this.$t('store.rolPbc')
          default:
            return x
        }
      }).join(', ')
    }
  },
  watch: {
    cambiado () {
      this.$emit('cambiado', this.cambiado)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/comerciales/ComercialesLista.vue